// extracted by mini-css-extract-plugin
export var linkText = "_p9-0";